export default "__VITE_ASSET__zAsjW5EPMaNQHKhwLtuBvw__"